var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuantumSafe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2046)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2046)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 13,
    width: 25,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13.25H12V38.25H37V13.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4479 15.3334H29.4687C27.1979 15.3334 26 16.5313 26 18.8021V20.7813C26 23.0521 27.1979 24.25 29.4687 24.25H31.4479C33.7188 24.25 34.9167 23.0521 34.9167 20.7813V18.8021C34.9167 16.5313 33.7188 15.3334 31.4479 15.3334Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5413 27.2393H17.5622C15.2809 27.2393 14.083 28.4372 14.083 30.708V32.6872C14.083 34.9684 15.2809 36.1663 17.5518 36.1663H19.5309C21.8018 36.1663 22.9997 34.9684 22.9997 32.6976V30.7184C23.0101 28.4372 21.8122 27.2393 19.5413 27.2393Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5518 24.2709C21.0198 24.2709 23.0205 22.2701 23.0205 19.8021C23.0205 17.3341 21.0198 15.3334 18.5518 15.3334C16.0837 15.3334 14.083 17.3341 14.083 19.8021C14.083 22.2701 16.0837 24.2709 18.5518 24.2709Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4473 36.1666C32.9153 36.1666 34.916 34.1659 34.916 31.6979C34.916 29.2299 32.9153 27.2291 30.4473 27.2291C27.9792 27.2291 25.9785 29.2299 25.9785 31.6979C25.9785 34.1659 27.9792 36.1666 30.4473 36.1666Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2046",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2046",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(12 13.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuantumSafe);
export default __webpack_public_path__ + "static/media/icon-quantum-safe.bd5a88f9c37f04f560ee0adb597a1be4.svg";
export { ForwardRef as ReactComponent };